import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { PnmacCard, PnmacPageBubble, PnmacPaper, PnmacParagraph, PnmacRadioButton, PnmacRadioButtonGroup, PnmacMediaQuery, PnmacUIButton, PnmacText, PnmacMeta } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import { UPDATE_LOAN_PREF } from '../redux/actions/actions.js';
import { SuccessMessage } from '../components/SuccessMessage.js';
import BannerView from "../v2/BannerView";
import { textStyle } from "../v2/theme";
import * as AppEvents from "../redux/events/events.js";
import { Text } from 'react-native';
var TrackerHitTypeLID_ENUM = AppEvents.TrackerHitTypeLID_ENUM,
  TrackerActionLID_ENUM = AppEvents.TrackerActionLID_ENUM,
  TrackerCategoryLID_ENUM = AppEvents.TrackerCategoryLID_ENUM,
  UserLanguage_ENUM = AppEvents.UserLanguage_ENUM;
var WisconsinTaxOptions = /** @class */function (_super) {
  __extends(WisconsinTaxOptions, _super);
  function WisconsinTaxOptions(props) {
    var _this = this;
    var _a;
    _this = _super.call(this, props) || this;
    _this.changeValue = function (value, property) {
      if (_this.state.isComponentMounted) {
        var _a = _this.state,
          loanPrferencesUpdate = _a.loanPrferencesUpdate,
          loanPreference_1 = _a.loanPreference;
        var index = loanPreference_1 === null || loanPreference_1 === void 0 ? void 0 : loanPreference_1.findIndex(function (s) {
          return parseInt(s.preferenceTypeCode) == parseInt(property);
        });
        if (index > -1) {
          loanPreference_1[index].changed = true;
          loanPreference_1[index].preferenceCode = value;
        } else {
          var l = __assign({}, loanPreference_1[0]);
          l.preferenceTypeCode = property;
          l.preferenceCode = value;
          l.active = true;
          l.appId = 23;
          l.changed = true;
          loanPreference_1.push(l);
        }
        _this.setState({
          loanPreference: loanPreference_1,
          loanPrferencesUpdate: true,
          allowShareAff: value
        }, function () {
          return _this.props.dispatch({
            type: UPDATE_LOAN_PREF,
            selectedLoanPreference: loanPreference_1
          });
        });
      }
    };
    _this.state = {
      optionsEnabled: true,
      loading: false,
      loanPrferencesUpdate: false,
      allowShareAff: null,
      isComponentMounted: false,
      loanPreference: (_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanPreference,
      confirmFinal: false,
      wisconsinPref: null
    };
    return _this;
  }
  WisconsinTaxOptions.prototype.componentDidMount = function () {
    var _this = this;
    this.setState({
      isComponentMounted: true
    });
    fetch("/api/loan/wisconsin_tax_info", {
      method: 'GET',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer ".concat(this.props.layout.token)
      }
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      _this.setState({
        optionsEnabled: data.optionsEnabled || false
      });
    });
  };
  // updateWisconsinPreference = () => {
  //     let { selectedLoanPreference, selectedLoanNumber } = this.props.layout
  //     let index = selectedLoanPreference.findIndex(s => s.preferenceTypeCode == 300089)
  //     if (index > -1) {
  //         selectedLoanPreference[index] = this.state.wisconsinPref
  //     } else {
  //         selectedLoanPreference.push(this.state.wisconsinPref)
  //     }
  //     if (parseInt(selectedLoanNumber) > 0) {
  //         selectedLoanPreference.forEach(s => s.loanId = selectedLoanNumber)
  //         fetch(`/api/loan/update_loan_preferences`, {
  //             method: 'POST',
  //             headers: {
  //                 "Content-Type": "application/json; charset=utf-8",
  //                 "Authorization": `Bearer ${this.props.layout.token}`
  //             },
  //             body: JSON.stringify(selectedLoanPreference)
  //         }).then(res => res.json()).then((data) => {
  //             if (data) {
  //                 this.setState({ loading: false })
  //             }
  //         });
  //     }
  // }
  WisconsinTaxOptions.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e;
    var layout = props.layout;
    if (!state.loanPreference || ((_a = state.loanPreference) === null || _a === void 0 ? void 0 : _a.length) == 0 || state.loanPreference != props.layout.selectedLoanPreference) {
      return __assign(__assign({}, state), {
        loanPreference: (_b = props.layout) === null || _b === void 0 ? void 0 : _b.selectedLoanPreference,
        wisconsinPref: (_c = props.layout) === null || _c === void 0 ? void 0 : _c.selectedLoanPreference.find(function (s) {
          return s.preferenceTypeCode == 300089;
        })
      });
    } else {
      return __assign(__assign({}, state), {
        loanPreference: (_d = props.layout) === null || _d === void 0 ? void 0 : _d.selectedLoanPreference,
        wisconsinPref: (_e = props.layout) === null || _e === void 0 ? void 0 : _e.selectedLoanPreference.find(function (s) {
          return s.preferenceTypeCode == 300089;
        })
      });
    }
  };
  WisconsinTaxOptions.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations,
      confirmFinal = _a.confirmFinal;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacPageBubble, {
        accessibilityRole: "header",
        ariaLevel: "1",
        text: translations.WisconsinTaxOptionsTitle,
        containerStyles: {
          marginLeft: 10
        }
      }), /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.WisconsinTaxOptionsTitle
      }), /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.DisplayMessageOne, " ", translations.DisplayMessageTwo, " ", translations.DisplayMessageThree)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "60%"
        }
      }, _this.state.confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.SuccessfullyUpdatedMessage
      }) : null, /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          backgroundColor: "#FFF",
          padding: 25,
          marginBottom: 20,
          borderRadius: 10,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "1px solid #e9e9e9",
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
        onValueChange: function (value) {
          return _this.changeValue(value, 300089);
        },
        value: _this.state.allowShareAff || (_this.state.wisconsinPref ? _this.state.wisconsinPref.preferenceCode : 0),
        style: {
          flexBasis: '20%',
          flexGrow: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: styles.wiscoTax.section
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "75%"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.OptionTextOne)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12,
          alignSelf: "flex-start",
          width: 70
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, "Select One")), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        disabled: !_this.state.optionsEnabled,
        value: 300090
      }))), /*#__PURE__*/React.createElement("div", {
        style: styles.wiscoTax.section
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "75%"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.OptionTextTwo)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12,
          alignSelf: "flex-start",
          width: 70
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        disabled: !_this.state.optionsEnabled,
        value: 300091
      }))), /*#__PURE__*/React.createElement("div", {
        style: styles.wiscoTax.section
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "75%"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.OptionTextThree)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12,
          alignSelf: "flex-start",
          width: 70
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        disabled: !_this.state.optionsEnabled,
        value: 300092
      }))), /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, styles.wiscoTax.section), {
          border: "transparent"
        })
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "75%"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.OptionTextFour)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12,
          alignSelf: "flex-start",
          width: 70
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        disabled: !_this.state.optionsEnabled,
        value: 300378
      }))))), _this.state.optionsEnabled ? /*#__PURE__*/React.createElement("div", {
        style: styles.accountSettings.buttonContainer
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        idTag7: 'lblSubmitButtonPnmacText',
        nativeID: "btnSubmitButtonPnmacText",
        name: "SubmitButtonPnmacText",
        testId: "SubmitButtonPnmacText",
        style: {
          width: matches.small ? "90%" : "25%",
          marginTop: 25
        },
        disabled: layout.pennyWise,
        loading: _this.state.loading,
        mode: "contained",
        testID: "SubmitButtonPnmacText",
        onPress: function () {
          _this.setState({
            loading: true
          });
          var _a = _this.props.layout,
            loanPreference = _a.loanPreference,
            loanPrferencesUpdate = _a.loanPrferencesUpdate,
            selectedLoanNumber = _a.selectedLoanNumber;
          var currentPlatform = layout.mobile ? "Mobile" : "Web";
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "WI Tax Option Change button clicked ".concat(currentPlatform), 0);
          if (parseInt(selectedLoanNumber) > 0) {
            loanPreference.forEach(function (s) {
              return s.loanId = selectedLoanNumber;
            });
            fetch("/api/loan/update_loan_preferences", {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              },
              body: JSON.stringify(loanPreference)
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              _this.setState({
                loading: false
              });
              if (data) {
                //Messsage to display
                _this.setState({
                  loading: false,
                  confirmFinal: true
                });
              }
            });
          }
        }
      }, translations.Change)) : null)));
    });
  };
  return WisconsinTaxOptions;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(WisconsinTaxOptions);